import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateModel } from '../core/_base/layout/models/translate.model';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  language_change$ = new BehaviorSubject<string>('en');

  constructor(private translate: TranslateService) {
  }

  loadTranslations(lang: string[]): void {
    this.translate.addLangs(lang);
    this.translate.setDefaultLang('en');
  }

  setLanguage(lang) {
    if (lang) {
      this.language_change$.next(lang);
      this.translate.use(lang);
      localStorage.setItem('language', lang);
    }
  }

  getSelectedLanguage(): string {
    return localStorage.getItem('language') || this.translate.getDefaultLang();
  }

  ML(data: any, key: string, $newValue, ML?: TranslateModel, lngParam?: string) {
    let lng = this.getSelectedLanguage();
    if (lngParam != undefined) {
      lng = lngParam;
    }
    let translateModel: TranslateModel;
    translateModel = new TranslateModel();
    try {
      if (data[key] == '') {
        translateModel = new TranslateModel();
      } else {
        try {
          translateModel = JSON.parse(data[key]);
        } catch {
          translateModel = JSON.parse(data);
        }
      }
      switch (lng) {
        case 'tr':
          translateModel.tr = $newValue;
          if (ML) {
            ML.tr = $newValue;
          }
          break;
        case 'en':
          translateModel.en = $newValue;
          if (ML) {
            ML.en = $newValue;
          }
          break;
        case 'ru':
          translateModel.ru = $newValue;
          if (ML) {
            ML.ru = $newValue;
          }
          break;
        case 'fr':
          translateModel.fr = $newValue;
          if (ML) {
            ML.fr = $newValue;
          }
          break;
        case 'de':
          translateModel.de = $newValue;
          if (ML) {
            ML.de = $newValue;
          }
          break;
        case 'ar':
          translateModel.ar = $newValue;
          if (ML) {
            ML.ar = $newValue;
          }
          break;
        case 'fa':
          translateModel.fa = $newValue;
          if (ML) {
            ML.fa = $newValue;
          }
          break;
        case 'es':
          translateModel.es = $newValue;
          if (ML) {
            ML.es = $newValue;
          }
          break;
        default:
          translateModel.en = $newValue;
          if (ML) {
            ML.en = $newValue;
          }
          break;
      }

    } catch (e) {
      translateModel = new TranslateModel();
      switch (lng) {
        case 'tr':
          translateModel.tr = $newValue;
          if (ML) {
            ML.tr = $newValue;
          }
          break;
        case 'en':
          translateModel.en = $newValue;
          if (ML) {
            ML.en = $newValue;
          }
          break;
        case 'ru':
          translateModel.ru = $newValue;
          if (ML) {
            ML.ru = $newValue;
          }
          break;
        case 'fr':
          translateModel.fr = $newValue;
          if (ML) {
            ML.fr = $newValue;
          }
          break;
        case 'de':
          translateModel.de = $newValue;
          if (ML) {
            ML.de = $newValue;
          }
          break;
        case 'ar':
          translateModel.ar = $newValue;
          if (ML) {
            ML.ar = $newValue;
          }
          break;
        case 'fa':
          translateModel.fa = $newValue;
          if (ML) {
            ML.fa = $newValue;
          }
          break;
        case 'es':
          translateModel.es = $newValue;
          if (ML) {
            ML.es = $newValue;
          }
          break;
        default:
          translateModel.en = $newValue;
          if (ML) {
            ML.en = $newValue;
          }
          break;
      }
    }

    try {
      data[key] = JSON.stringify(translateModel);
    } catch {
      data = JSON.stringify(translateModel);
    }

  }

}
